import React, { Component } from 'react';
import ReactGA from 'react-ga';
import logo from './logo.svg';
import './App.css';
import Emails from './components/form/index.js'
import { Grid, Row, Col } from 'react-flexbox-grid';
import 'normalize.css';

// import Firebase and ReactFire


// Initialize Firebase
// TODO: Replace with your project's customized code snippet


class App extends Component {
  constructor () {
    super()
    
    // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
    ReactGA.initialize('UA-2682785-13');
    // This just needs to be called once since we have no routes in this case.
    ReactGA.pageview(window.location.pathname);    
  }
  
  render() {
  return(
    <Grid fluid>
      <Row center='xs'>
        <Col xs={12} sm={8} md={6} lg={5}>
          <Emails />
        </Col>
      </Row>
    </Grid>
    );
  }
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js